import types from './types';

const INITIAL_STATE = {
  announcementBarVisible: true,
  urgentAnnouncementBarVisible: false,

  result: [],
};

const appAnnouncementsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.SHOW_ANNOUNCEMENT_BAR:
      return {
        ...state,
        result: [],
        announcementBarVisible: true,
      };

    case types.CLOSE_ANNOUNCEMENT_BAR:
      return {
        ...state,
        result: [],
        announcementBarVisible: false,
      };

    case types.SHOW_URGENT_ANNOUNCEMENT_BAR:
      return {
        ...state,
        result: [],
        urgentAnnouncementBarVisible: true,
      };

    case types.CLOSE_URGENT_ANNOUNCEMENT_BAR:
      return {
        ...state,
        result: [],
        urgentAnnouncementBarVisible: false,
      };



    default:
      return state;
  }
};

export default appAnnouncementsReducer;
